import { Alert, Box } from '@mui/material';
import { CircleCheckBig } from 'lucide-react';

import { WithSx } from '@/utils/types';

export default function SuccessBanner({ children, sx }: WithSx) {
  return (
    <Box justifyContent="center" sx={sx}>
      <Alert
        icon={<CircleCheckBig className="text-foreground size-4" />}
        severity="success"
        sx={{
          height: 'auto',
          backgroundColor: 'success.main',
          color: 'success.light',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {children}
      </Alert>
    </Box>
  );
}
